export const formatCoordinateToNumber = (value: string | number) => {
  if (typeof value === 'string') {
    return parseFloat(value);
  }
  return value;
};
